import moment from "moment";
import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import Api from "../../../../Services/Api";
import { fetchDataAsync } from "../../../../Services/Utils";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleInput from "../../../../modules/SimpleInput";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import { HttpStatus } from "../../../common/Constants";
import { mapToObjectDDL } from "../../../common/mapper";

class FakturJualBengkelDGIFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kabKotOptions: [],
      kecamatanOptions: [],
      kelurahanOptions: [],
      warnaOptions: [],
      unitTypeOptions: [],
      provinceOptions:[],
      filter: null,
      dealerIdOptions: []
    };
  }

  componentDidMount = () => {
    this.loadData();
  };

  loadData = async () => {
    const { setError, onClickClose, onTriggerLoading, submittedFilterData, kodeCabang } =
      this.props;
    if (submittedFilterData) {
      this.setState({
        filter: submittedFilterData || {},
      });
    }
    const menuName = "Faktur Jual Bengkel";
    const api = Api.create("NAGAMAS_MASTER_DATA");

    onTriggerLoading();

    const [provinceRes, variantRes, dealerRes] = await Promise.all([
      fetchDataAsync({ asyncFn: api.getAllProvince, setError, menuName }),
      fetchDataAsync({
        asyncFn: api.getAllVariant,
        setError,
        menuName,
        args: "",
      }),
      fetchDataAsync({
        asyncFn: api.getDealerAhmByKodeCabang,
        setError,
        menuName,
        args: kodeCabang,
      }),
    ]);

    if (
      provinceRes?.data?.status !== HttpStatus.SUCCESS ||
      variantRes?.data?.status !== HttpStatus.SUCCESS
    ) {
      onTriggerLoading();
      onClickClose();
      return;
    }

    const provinceOptions = provinceRes.data.data.map((d) =>
      mapToObjectDDL(d.provinceName, d.id)
    );
    const unitTypeOptions = variantRes.data.data.map((d) =>
      mapToObjectDDL(d.namaVariant, d.kodeVariant)
    );

    const dealerIdOptions = dealerRes?.data?.data?.map(item=>mapToObjectDDL(item, item))

    this.setState((prevState) => ({
      ...prevState,
      provinceOptions,
      unitTypeOptions,
      dealerIdOptions
    }));
    onTriggerLoading();
  };

  handleValueChange = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        [name]: value,
      },
    }));
  };

  handleProvinceChange = async (name, value) => {
    this.setState((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        kabKotId: null,
        kecamatanId: null,
        kelurahanId: null,
        [name]: value,
      },
      kabKotOptions: [],
      kecamatanOptions: [],
      kelurahanOptions: [],
    }));

    if (!R.isNil(value)) {
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllCity,
        setError: this.props.setError,
        menuName: "Sales Order - Faktur Jual",
        args: value?.value,
      });

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.setState((prevState) => ({
          ...prevState,
          kabKotOptions: res.data.data.map((item) =>
            mapToObjectDDL(item.kabKotName, item.kabKotId)
          ),
        }));
      }
    }
  };

  handleKabKotChange = async (name, value) => {
    this.setState((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        kodeKecamatan: null,
        kodeKelurahan: null,
        [name]: value,
      },
      kecamatanOptions: [],
      kelurahanOptions: [],
    }));

    if (!R.isNil(value)) {
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan,
        setError: this.props.setError,
        menuName: "Sales Order - Faktur Jual",
        args: value?.value,
      });

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.setState((prevState) => ({
          ...prevState,
          kecamatanOptions: res.data.data.map((item) =>
            mapToObjectDDL(item.kecamatanName, item.id)
          ),
        }));
      }
    }
  };

  handleKecamatanChange = async (name, value) => {
    this.setState((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        kodeKelurahan: null,
        [name]: value,
      },
      kelurahanOptions: [],
    }));

    if (!R.isNil(value)) {
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan,
        setError: this.props.setError,
        menuName: "Sales Order - Faktur Jual",
        args: value?.value,
      });

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.setState((prevState) => ({
          ...prevState,
          kelurahanOptions: res.data.data.map((item) =>
            mapToObjectDDL(item.kelurahanname, item.id)
          ),
        }));
      }
    }
  };

  handleVarianChange = async (name, value) => {
    this.setState((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        kodeWarna: null,
        [name]: value,
      },
      warnaOptions: [],
    }));

    if (!R.isNil(value)) {
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllWarnaByParam,
        setError: this.props.setError,
        menuName: "Sales Order - Faktur Jual",
        args: { paramFilters: { kodeVariant: value?.value } },
      });

      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.setState((prevState) => ({
          ...prevState,
          warnaOptions: res.data.data.map((item) =>
            mapToObjectDDL(item.namaWarnaKomersil, item.id)
          ),
        }));
      }
    }
  };

  handleClearFilter = () => {
    this.setState(prev=>({
      ...prev,
      kabKotOptions: [],
      kecamatanOptions: [],
      kelurahanOptions: [],
      filter: {
        kelurahanId: null,
        provinceId: null,
        kabKotId: null,
        kecamatanId: null,
        startPeriod: null,
        endPeriod: null,
        dealerId: null,
        ownerName: null,
        carrierName: null,
        address: null,
        variantCode: null,
        frameNo: null,
        engineNo: null,
      },
    }));
  };

  handleSubmitFilter = () => {
    const { onClickClose, onSubmit } = this.props;
    const { filter } = this.state;
    onSubmit(filter);
    onClickClose();
  };

  render() {
    const { visible, onClickClose } = this.props;
    const {
      filter,
      kecamatanOptions,
      kelurahanOptions,
      unitTypeOptions,
      dealerIdOptions,
    } = this.state;
    console.log(filter)
    return (
      <React.Fragment>
        <SimpleModal
          title="Filter Search"
          visible={visible}
          onClickClose={() => onClickClose()}
          content={
            <ModalContainer>
              <FlexView column>
                <FlexView column vAlignContent="center">
                  <h4 className="txt-site txt-11 txt-main txt-bold">
                    Tanggal Service:
                  </h4>
                  <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                    <div style={{ width: "100%" }}>
                      <SimpleDate
                        id={`select_date_startTanggalFjb`}
                        name="startPeriod"
                        nextdate
                        date={filter?.startPeriod}
                        maxDate={filter?.endPeriod}
                        onChange={(value) =>
                          this.handleValueChange(
                            "startPeriod",
                            moment(value)?.format("DD-MM-YYYY")
                          )
                        }
                      />
                    </div>
                    <span className="margin-bottom-20px">To</span>
                    <div style={{ width: "100%" }}>
                      <SimpleDate
                        id={`select_date_endTanggalFjb`}
                        name="endTanggalFjb"
                        nextdate
                        date={filter?.endTanggalFjb}
                        onChange={(value) =>
                          this.handleValueChange(
                            "endPeriod",
                            moment(value)?.format("DD-MM-YYYY")
                          )
                        }
                      />
                    </div>
                  </FlexView>
                </FlexView>

                <SimpleDDL
                  id="select_options_dealer_id"
                  name="dealerAhm"
                  label="Dealer ID"
                  box="search"
                  isClearable
                  options={dealerIdOptions}
                  value={filter?.dealerAhm}
                  onChange={(value, { name }) =>
                    this.handleValueChange(name, value)
                  }
                />
                <SimpleInput
                  id="input_text_nama_pemilik"
                  name="ownerName"
                  label="Nama Pemilik"
                  value={filter?.ownerName}
                  onChange={({ target }) =>
                    this.handleValueChange(target.name, target.value)
                  }
                />
                <SimpleInput
                  id="input_text_nama_pembawa"
                  name="carrierName"
                  label="Nama Pembawa"
                  value={filter?.carrierName}
                  onChange={({ target }) =>
                    this.handleValueChange(target.name, target.value)
                  }
                />
                <SimpleInput
                  id="input_text_alamat"
                  name="address"
                  label="Alamat"
                  value={filter?.address}
                  onChange={({ target }) =>
                    this.handleValueChange(target.name, target.value)
                  }
                />
                <SimpleDDL
                  id="select_options_provinsi"
                  name="provinceId"
                  label="Nama Provinsi"
                  box="search"
                  isClearable
                  options={this.state?.provinceOptions}
                  value={filter?.provinceId}
                  onChange={(value, { name }) =>
                    this.handleProvinceChange(name, value)
                  }
                />
                <SimpleDDL
                  id="select_options_kota"
                  name="kabKotId"
                  label="Nama Kota"
                  box="search"
                  isClearable
                  options={this.state?.kabKotOptions}
                  value={filter?.kabKotId}
                  onChange={(value, { name }) =>
                    this.handleKabKotChange(name, value)
                  }
                />
                <SimpleDDL
                  id="select_options_kecamatan"
                  name="kecamatanId"
                  label="Nama Kecamatan"
                  box="search"
                  isClearable
                  options={kecamatanOptions}
                  value={filter?.kecamatanId}
                  onChange={(value, { name }) =>
                    this.handleKecamatanChange(name, value)
                  }
                />
                <SimpleDDL
                  id="select_options_kelurahan"
                  name="kelurahanId"
                  label="Nama Kelurahan"
                  box="search"
                  isClearable
                  options={kelurahanOptions}
                  value={filter?.kelurahanId}
                  onChange={(value, { name }) =>
                    this.handleValueChange(name, value)
                  }
                />
                <SimpleDDL
                  id="select_options_tipe_unit"
                  name="variantCode"
                  label="Kode Varian"
                  box="search"
                  isClearable
                  options={unitTypeOptions}
                  value={filter?.variantCode}
                  onChange={(value, { name }) =>
                    this.handleVarianChange(name, value)
                  }
                />
                <SimpleInput
                  id="select_options_kode_warna"
                  name="frameNo"
                  label="No Rangka"
                  value={filter?.frameNo}
                  onChange={({ target }) =>
                    this.handleValueChange(target.name, target.value)
                  }
                />
                <SimpleInput
                  id="select_options_nomor_mesin"
                  name="engineNo"
                  label="Nomor Mesin"
                  value={filter?.engineNo}
                  onChange={({ target }) =>
                    this.handleValueChange(target.name, target.value)
                  }
                />
              </FlexView>
              <FlexView hAlignContent="right" style={{ gap: "10px" }}>
                <SimpleButton text="Clear" onClick={this.handleClearFilter} />
                <SimpleButton
                  text="Terapkan"
                  onClick={this.handleSubmitFilter}
                />
              </FlexView>
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default FakturJualBengkelDGIFilter;
